import SingleUploadComponent from "@components/common/single-upload";
import { useNavigation } from "@context/navigation-provider";
import HomeLayout from "@layouts/HomeLayout";
import { updateSpecificUser } from "@services/users.service";
import { getValue } from "@utils/lodash";
import { Button, Input, message, Popconfirm } from "antd";
import React, { useEffect, useState } from "react";
import { PhoneInput } from "react-international-phone";

function profilePictures(value: any) {
  const list = Array.isArray(value) ? value : value?.url ? [value] : [];
  return list
    .map((item: any, index: number) => {
      const url = typeof item === "string" ? item : item?.url || "";
      if (!url) return null;
      return {
        uid: item?.uid || `profile-${index}`,
        name: item?.name || "profile",
        status: "done",
        url,
      };
    })
    .filter(Boolean);
}

function SettingsAccountsPage(props: any) {
  /* -------------------------------------------------------------------------- */
  /*                               Hooks Section                                */
  /* -------------------------------------------------------------------------- */

  const [request, setRequest] = useState<any>({
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    profile_pic: [],
  });

  function isFormEmpty() {
    // Loop through each field in the request object
    for (let key in request) {
      if (request[key]) {
        return false; // Return false if any field is not empty
      }
    }
    return true; // Return true if all fields are empty
  }

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */
  const { userInfo, getUserInfoCallback } = useNavigation();

  useEffect(() => {
    if (getValue(userInfo, `id`, "")) {
      setRequest((prevState: any) => ({
        ...prevState,
        first_name: getValue(userInfo, `first_name`, ""),
        last_name: getValue(userInfo, `last_name`, ""),
        email: getValue(userInfo, `email`, ""),
        phone_number: getValue(userInfo, `phone_number`, ""),
        profile_pic: profilePictures(getValue(userInfo, `profile_pic`, [])),
      }));
    }
  }, [userInfo]);
  const handleDelete = async () => {
    try {
      let resp = await updateSpecificUser(getValue(userInfo, `id`, ""), {
        is_active: false,
      });
      if (resp) {
        localStorage.clear();
        message.success("Account removed successfully");
        window.location.href = "/";
      }
    } catch (error) {}
  };
  const [submitLoading, setSubmitLoading] = useState(false);
  const handleUpdateUser = async () => {
    try {
      setSubmitLoading(true);
      const pictures = profilePictures(request.profile_pic);
      let resp = await updateSpecificUser(getValue(userInfo, `id`, ""), {
        first_name: request.first_name,
        last_name: request.last_name,
        email: request.email,
        phone_number: request.phone_number,
        profile_pic: pictures.map((item: any) => ({ url: item.url })),
      });
      if (resp) {
        setSubmitLoading(false);
        message.success(getValue(resp, `message`, ""));
        getUserInfoCallback();
      } else {
        setSubmitLoading(false);
      }
    } catch (error) {
      setSubmitLoading(false);
    }
  };
  return (
    <HomeLayout>
      <div className="account-page">
        <div className="account-head">
          <div>
            <h2>Account</h2>
            <p>Photo, name, email, and phone.</p>
          </div>
          <Popconfirm
            title="Are you sure you want to delete account?"
            okText="Yes"
            cancelText="No"
            onConfirm={handleDelete}
          >
            <Button danger>Delete account</Button>
          </Popconfirm>
        </div>
        <div className="account-card">
          <div className="account-photo">
            <SingleUploadComponent
              listType="picture-circle"
              imageUrls={getValue(request, `profile_pic`, [])}
              uploadSuccess={(e: any) => {
                setRequest({
                  ...request,
                  profile_pic: [e],
                });
              }}
              uploadRemove={() => {
                setRequest({
                  ...request,
                  profile_pic: [],
                });
              }}
            />
          </div>
          <div className="account-fields">
            <div>
              <label htmlFor="first_name">First name</label>
              <Input
                id="first_name"
                value={getValue(request, `first_name`, "")}
                onChange={(e) =>
                  setRequest({ ...request, first_name: e.target.value })
                }
              />
            </div>
            <div>
              <label htmlFor="last_name">Last name</label>
              <Input
                id="last_name"
                value={getValue(request, `last_name`, "")}
                onChange={(e) =>
                  setRequest({ ...request, last_name: e.target.value })
                }
              />
            </div>
            <div>
              <label htmlFor="email">Email</label>
              <Input
                id="email"
                value={getValue(request, `email`, "")}
                onChange={(e) =>
                  setRequest({ ...request, email: e.target.value })
                }
              />
            </div>
            <div>
              <label htmlFor="phone_number">Phone</label>
              <PhoneInput
                value={getValue(request, `phone_number`, "") || ""}
                defaultCountry="in"
                onChange={(value) =>
                  setRequest({ ...request, phone_number: value })
                }
              />
            </div>
          </div>
          <div className="account-actions">
            <Button type="primary" loading={submitLoading} onClick={handleUpdateUser}>
              Save
            </Button>
          </div>
        </div>
      </div>
    </HomeLayout>
  );
}

export default SettingsAccountsPage;
